import React, { useEffect } from 'react'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { observer } from 'mobx-react'

const AddReason = ({ initialValue }) => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  useEffect(() => {
    if (initialValue) {
      changeValues(initialValue, 'value')
    }
  }, [initialValue, changeValues])

  return (
    <FormField>
      <FormLabel isRequired>Reason:</FormLabel>
      <FormInput isError={check('value')}>
        <input
          name='name'
          onChange={(e) => changeValues(e.target.value, 'value')}
          placeholder='Enter the reason name'
          value={modalValue?.value || ''}
          autoFocus
        />
      </FormInput>
    </FormField>
  )
}

export default observer(AddReason)
